import { white } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
import { palette } from '../palette';
export var MuiPaper = {
    styleOverrides: {
        root: {
            backgroundImage: 'none',
            '& .YdsInboxMessageHeader-leadingIcon': {
                backgroundColor: palette.text.secondary,
                borderRadius: '50%',
                color: white,
                height: rem(24),
                marginInlineEnd: rem(8),
                padding: rem(4),
                width: rem(24),
            },
            '& .YdsInboxMessageHeader-leadingIconImportant': {
                backgroundColor: palette.error.main,
            },
        },
    },
};
